import { createAction } from "redux-actions";
import {
  SET_CATEGORY_ERROR,
  CLEAR_CATEGORY_DETAILS,
  CLEAR_CATEGORY_ERROR
} from "../constants";

export const setCategoryError = createAction(SET_CATEGORY_ERROR);

export const clearCategoryError = createAction(CLEAR_CATEGORY_ERROR);

export const clearCategoryDetails = createAction(CLEAR_CATEGORY_DETAILS);
